import { useSite } from "../../context/SiteContext";
import { WHATSAPP_URL } from "../../lib/core";
import { BookButton } from "./BookButton";

const WaIcon = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" aria-hidden="true">
    <path d="M16 3C9 3 3.3 8.6 3.3 15.6c0 2.2.6 4.4 1.7 6.3L3 29l7.3-1.9c1.8 1 3.8 1.5 5.8 1.5 7 0 12.7-5.6 12.7-12.6S23 3 16 3zm0 23.2c-1.9 0-3.7-.5-5.3-1.4l-.4-.2-4.3 1.1 1.2-4.2-.3-.4c-1-1.7-1.6-3.6-1.6-5.5C5.3 9.8 10.1 5.1 16 5.1s10.7 4.7 10.7 10.5S21.9 26.2 16 26.2zm5.9-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5.1-.2.1-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.2 1.4 3.5c.2.2 2.4 3.6 5.8 5 .8.4 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

export const MobileBar = () => {
  const { pricing, fmt } = useSite();
  return (
    <>
      <div
        data-testid="mobile-sticky-bottom-bar"
        className="fixed inset-x-0 bottom-0 z-40 border-t border-[#D4AF37]/70 bg-[#0A0A0A]/95 px-4 pb-[max(10px,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-xl md:hidden"
      >
        <div className="flex items-center justify-between gap-3">
          <p className="leading-tight">
            <span data-testid="mobile-bar-price" className="block text-base font-bold text-[#F5F0E6]">{fmt(pricing?.tier?.single_price)} + GST</span>
            <span className="block text-xs font-medium tracking-wide text-[#A39E93]">15 Nov, Whitefield</span>
          </p>
          <BookButton plan="single" size="sm" testid="mobile-book-button" className="px-7">Book Now</BookButton>
        </div>
      </div>
      <a
        data-testid="whatsapp-float-button"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-[calc(80px+env(safe-area-inset-bottom))] right-4 z-40 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#25D366] shadow-[0_0_0_2px_#0A0A0A,0_0_0_3.5px_#D4AF37,0_14px_30px_-10px_rgba(0,0,0,.8)] transition-transform duration-300 hover:scale-110 sm:right-6 md:bottom-6"
      >
        <WaIcon />
      </a>
    </>
  );
};
